export default {
    cancelText: '取消'
};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/antd-mobile/es/search-bar/locale/zh_CN.js
// module id = 2880
// module chunks = 0